import dashboardBundleService from '@/services/dashboard/event_dashboard_bundle'

export default {
  async get(eventId, options = {}) {
    const empty = {
      totalTables: 0,
      fullTables: 0,
      tablesWithAvailability: 0,
      unassignedGuests: 0
    }

    if (!eventId) {
      return empty
    }

    try {
      const bundle = await dashboardBundleService.get(eventId, options)
      const tables = bundle.tables || []
      const guests = bundle.guests || []

      const activeGuests = guests.filter(g => Number(g.is_confirm || 0) !== 2)
      const tableIdsWithGuests = new Set(
        activeGuests
          .map(g => Number(g.event_table_id || 0))
          .filter(id => id > 0)
      )

      const totalTables = tables.length
      const fullTables = tableIdsWithGuests.size
      const tablesWithAvailability = Math.max(totalTables - fullTables, 0)
      const unassignedGuests = activeGuests.filter(g => Number(g.event_table_id || 0) <= 0).length

      return {
        totalTables,
        fullTables,
        tablesWithAvailability,
        unassignedGuests
      }
    } catch (error) {
      return empty
    }
  },

  invalidate(eventId) {
    dashboardBundleService.invalidate(eventId)
  }
}
